import { atom } from "jotai";
import { Document } from "models";

/**
 * Atom which stores the currently selected document
 */
export const documentAtom = atom<Document | null>(null);
